import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { CaretDownIcon, CheckIcon } from '@yonderland/andes-icons';
import { ConditionalWrapper, Icon, LinkButton, ListBox, Popover, Stack, TextAlpha } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useProductListerContext } from '../context';
export const SortFilter = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { urlState, updateSort } = useProductListerContext();
    const { lister: { sort: sortConfiguration }, } = useAemConfig();
    const getCurrentOrderItem = () => {
        const currentOrder = urlState.sort || sortConfiguration.defaultValue;
        const foundItem = sortConfiguration.properties.find(orderItem => orderItem.key === currentOrder);
        if (foundItem)
            return foundItem;
        return sortConfiguration.properties[0];
    };
    const [currentOrderItem, setCurrentOrderItem] = useState(getCurrentOrderItem);
    useEffect(() => {
        setCurrentOrderItem(getCurrentOrderItem);
    }, [sortConfiguration.properties, urlState.sort]);
    const sortOptions = sortConfiguration.properties.map((item) => ({
        key: item.key,
        state: item.key === currentOrderItem.key ? 'selected' : 'enabled',
        onClick: () => updateSort(item.key),
        text: t(item.value),
    }));
    return (_jsxs(Popover, { placement: "bottom-end", testId: "sort-filter-popover", slim: true, offsetOptions: { mainAxis: 8 }, customWidth: "280px", children: [_jsx(Popover.Trigger, { children: _jsxs(Stack, { wrap: "wrap", align: "center", gap: "1", children: [_jsxs(TextAlpha, { as: "span", children: [t('product:product.sort'), ": "] }), _jsxs(LinkButton, { theme: "neutral", variant: "primary", size: "md", children: [t(`product:${currentOrderItem.value}`), _jsx(Icon, { size: "sm", source: CaretDownIcon })] })] }) }), _jsx(Popover.Body, { children: _jsx(ListBox, { children: _jsx(ListBox.Group, { children: sortOptions.map(button => (_jsx(ListBox.Item, Object.assign({}, button, { paddingInline: "3", children: _jsx(ConditionalWrapper, { condition: button.state === 'selected', wrapper: children => (_jsxs(Stack, { direction: "row", align: "center", gap: "2", children: [_jsx(Icon, { source: CheckIcon, color: "emphasised", size: "sm" }), children] })), children: button.text }) })))) }) }) })] }));
};
